// https://govuk-elements.herokuapp.com/data/
import styled from 'react-emotion';
var TableBody = styled('tbody')();
export default TableBody;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/table/es/atoms/TableBody/index.js
// module id = 308
// module chunks = 0